
import 'notie/dist/notie.css';
import notie from 'notie';
/* eslint-disable */
(function (angular){
  const sweet = angular.module('ngNotie', []);
  
  const service = function ($rootScope) {
    this.alert = function (args) {
      notie.alert(args);
    };
    
    this.confirm = function (args) {
      notie.confirm(args);
    };
    
    this.input = function (args) {
      notie.input(args);
    };
  };
  sweet.service('notie', ['$rootScope', service]);
}(angular));
/* eslint-enable */
